import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDiGj9NLDU2t0yes9YfgpCerjaOhpGaP3M",
  authDomain: "wedding-cc.duckdns.org",
  projectId: "wedding-cc",
  storageBucket: "wedding-cc.firebasestorage.app",
  messagingSenderId: "950240326884",
  appId: "1:950240326884:web:879603762b672cccfb28f1",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export default app;
